import { render, staticRenderFns } from "./telegram.vue?vue&type=template&id=3eecc67e&scoped=true&"
import script from "./telegram.vue?vue&type=script&lang=js&"
export * from "./telegram.vue?vue&type=script&lang=js&"
import style0 from "./telegram.vue?vue&type=style&index=0&id=3eecc67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eecc67e",
  null
  
)

export default component.exports